var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNuxt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80452 0.786769C8.24558 -0.262216 6.84805 -0.262216 6.28902 0.786769L0.196709 12.219C-0.362239 13.268 0.336524 14.5792 1.45458 14.5792H6.21047C5.73273 14.1236 5.55581 13.3353 5.91743 12.659L10.5313 4.0272L8.80452 0.786769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6648 3.29444C13.1274 2.43624 14.2839 2.43624 14.7466 3.29444L19.7885 12.648C20.2511 13.5063 19.6728 14.5792 18.7475 14.5792H8.66377C7.73853 14.5792 7.16025 13.5063 7.62287 12.648L12.6648 3.29444Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9513,
    height: 14.6295,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuxt);
export default __webpack_public_path__ + "static/media/nuxt.79df6a3c6f5559752b25ea82ff17c03d.svg";
export { ForwardRef as ReactComponent };